import { render, staticRenderFns } from "./CmgNutritionCalculatorRecents.vue?vue&type=template&id=00d13fac&scoped=true&lang=pug"
import script from "./cmg-nutrition-calculator-recents.ts?vue&type=script&lang=ts&external"
export * from "./cmg-nutrition-calculator-recents.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgNutritionCalculatorRecents.vue?vue&type=style&index=0&id=00d13fac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d13fac",
  null
  
)

export default component.exports